export default __webpack_public_path__ + "static/media/exordium-poster-w990.ff326007.webp";